var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-plan-content"},[(_vm.planListData.length === 0)?_c('p',{staticClass:"mt-5 text-center font-weight-bold"},[_vm._v("尚未建立登山計畫")]):_vm._e(),_vm._l((_vm.newListData),function(item,index){return _c('MyPlanGroupCard',{key:index,attrs:{"card-data":item,"card-type":_vm.planType}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }